<div class="{{pageFooter}} pb-2 pt-2 page-footer footer "  id="mu-college">
    	<div [class]="containerCss">
			<div class="row" [innerHTML]="footerHTML"></div>
		</div>
</div>